const isTestEnvironment = (): boolean => process.env.NODE_ENV?.toLowerCase() === 'test';

export default isTestEnvironment;
